import { useState } from 'react';

export default function Appointment() {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    carBrand: '',
    carModel: '',
    service: '',
    date: '',
    message: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formBody.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d4rhs8cs30cg0huicrdg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString(),
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          name: '',
          phone: '',
          email: '',
          carBrand: '',
          carModel: '',
          service: '',
          date: '',
          message: '',
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <section id="appointment" className="py-16 sm:py-20 lg:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="rounded-2xl sm:rounded-3xl overflow-hidden mb-8 sm:mb-12" style={{ height: '200px' }}>
          <img
            src="https://public.readdy.ai/ai/img_res/6dbb3d088960a2835a0d3bfa31d9b697.jpg"
            alt="Workshop"
            className="w-full h-full object-cover"
          />
        </div>

        <div className="text-center mb-8 sm:mb-12 px-4">
          <h2 className="font-serif text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-bold text-gray-900 leading-relaxed">
            <em className="text-gray-600">Aracınız</em> için en iyi bakımı<br />
            <strong>profesyonel ekibimizden</strong><br />
            hemen randevu alarak başlatın
          </h2>
        </div>

        <div className="max-w-3xl mx-auto bg-white rounded-xl sm:rounded-2xl shadow-xl p-6 sm:p-8 lg:p-12">
          <form id="appointment-form" data-readdy-form onSubmit={handleSubmit} className="space-y-4 sm:space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
              <div>
                <label htmlFor="name" className="block font-sans text-sm font-medium text-gray-700 mb-2">
                  Ad Soyad *
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  required
                  value={formData.name}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg font-sans text-sm focus:ring-2 focus:ring-accent-gold focus:border-transparent"
                  placeholder="Adınız ve soyadınız"
                />
              </div>
              <div>
                <label htmlFor="phone" className="block font-sans text-sm font-medium text-gray-700 mb-2">
                  Telefon *
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  required
                  value={formData.phone}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg font-sans text-sm focus:ring-2 focus:ring-accent-gold focus:border-transparent"
                  placeholder="0555 123 45 67"
                />
              </div>
            </div>

            <div>
              <label htmlFor="email" className="block font-sans text-sm font-medium text-gray-700 mb-2">
                E-posta *
              </label>
              <input
                type="email"
                id="email"
                name="email"
                required
                value={formData.email}
                onChange={handleChange}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg font-sans text-sm focus:ring-2 focus:ring-accent-gold focus:border-transparent"
                placeholder="ornek@email.com"
              />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
              <div>
                <label htmlFor="carBrand" className="block font-sans text-sm font-medium text-gray-700 mb-2">
                  Araç Markası *
                </label>
                <input
                  type="text"
                  id="carBrand"
                  name="carBrand"
                  required
                  value={formData.carBrand}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg font-sans text-sm focus:ring-2 focus:ring-accent-gold focus:border-transparent"
                  placeholder="Araç markası"
                />
              </div>
              <div>
                <label htmlFor="carModel" className="block font-sans text-sm font-medium text-gray-700 mb-2">
                  Araç Modeli *
                </label>
                <input
                  type="text"
                  id="carModel"
                  name="carModel"
                  required
                  value={formData.carModel}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg font-sans text-sm focus:ring-2 focus:ring-accent-gold focus:border-transparent"
                  placeholder="Araç modeli"
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
              <div>
                <label htmlFor="service" className="block font-sans text-sm font-medium text-gray-700 mb-2">
                  Hizmet Türü *
                </label>
                <select
                  id="service"
                  name="service"
                  required
                  value={formData.service}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg font-sans text-sm focus:ring-2 focus:ring-accent-gold focus:border-transparent cursor-pointer"
                >
                  <option value="">Seçiniz</option>
                  <option value="Hasar Danışmanlığı">Hasar Danışmanlığı</option>
                  <option value="Kaza Onarımı">Kaza Onarımı</option>
                  <option value="Motor Rektifiye">Motor Rektifiye</option>
                  <option value="Mekanik Tamir">Mekanik Tamir</option>
                  <option value="Şanzıman Tamir">Şanzıman Tamir</option>
                  <option value="DR.ECU Yazılım">DR.ECU Yazılım</option>
                  <option value="Araç Check-Up">Araç Check-Up</option>
                  <option value="Arıza Teşhis">Arıza Teşhis</option>
                </select>
              </div>
              <div>
                <label htmlFor="date" className="block font-sans text-sm font-medium text-gray-700 mb-2">
                  Tercih Edilen Tarih *
                </label>
                <input
                  type="date"
                  id="date"
                  name="date"
                  required
                  value={formData.date}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg font-sans text-sm focus:ring-2 focus:ring-accent-gold focus:border-transparent cursor-pointer"
                />
              </div>
            </div>

            <div>
              <label htmlFor="message" className="block font-sans text-sm font-medium text-gray-700 mb-2">
                Ek Notlar
              </label>
              <textarea
                id="message"
                name="message"
                rows={4}
                maxLength={500}
                value={formData.message}
                onChange={handleChange}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg font-sans text-sm focus:ring-2 focus:ring-accent-gold focus:border-transparent resize-none"
                placeholder="Aracınızla ilgili detayları belirtebilirsiniz (Maksimum 500 karakter)"
              ></textarea>
              <p className="text-xs text-gray-500 mt-1">{formData.message.length}/500 karakter</p>
            </div>

            {submitStatus === 'success' && (
              <div className="bg-green-50 border border-green-200 text-green-800 px-4 py-3 rounded-lg font-sans text-sm">
                Randevunuz başarıyla alındı! En kısa sürede sizinle iletişime geçeceğiz.
              </div>
            )}

            {submitStatus === 'error' && (
              <div className="bg-red-50 border border-red-200 text-red-800 px-4 py-3 rounded-lg font-sans text-sm">
                Bir hata oluştu. Lütfen tekrar deneyin veya telefon ile iletişime geçin.
              </div>
            )}

            <div className="text-center pt-2 sm:pt-4">
              <button
                type="submit"
                disabled={isSubmitting}
                className="bg-black text-white px-8 sm:px-12 py-3 sm:py-4 rounded-full font-sans text-sm sm:text-base font-semibold hover:bg-accent-gold transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer w-full sm:w-auto"
              >
                {isSubmitting ? 'Gönderiliyor...' : 'Hemen Randevu Al'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
}